<template>
  <div class="loginBg">
    <!-- <img class="loginBg" src="@/assets/img/loginBg.jpeg"> -->
    <div class="loginz">
      <div class="login"></div>
    </div>

    <div class="form"
         v-bind:style="{ Width: EchartsWidth }">
      <div class="logo1">
        <img style="height: 50px"
             src="~assets/skzn.png" />
      </div>
      <!-- <div class="logo1">
        <img style="height: 50px" src="~assets/logo.png" />
      </div>
      <div class="logo1">
        <img style="height: 50px" src="~assets/logo1.png" />
      </div> -->
      <div class="form-tit">欢迎登录工单管理系统</div>

      <div class="form-con">
        <el-form ref="form"
                 :model="form"
                 :rules="formRule">
          <div class="form-titxiao">账号</div>
          <el-form-item class="shurukuanggaodu"
                        label=""
                        prop="user">
            <el-input prefix-icon="el-icon-login-user"
                      v-model="form.user"
                      clearable
                      placeholder="请输入用户名">
            </el-input>
          </el-form-item>
          <div class="form-titxiao">密码</div>
          <el-form-item class="shurukuanggaodu"
                        label=""
                        prop="pass">
            <el-input prefix-icon="el-icon-login-pad"
                      v-model="form.pass"
                      clearable
                      show-password
                      placeholder="请输入密码"
                      @keyup.enter.native="submitForm"></el-input>
          </el-form-item>

          <!-- <el-form-item label="" prop="code">
          <div class="form-code">
            <el-input class="form-code-input" v-model="form.code"></el-input>
            <el-image
              class="form-code-img"
              fit="fill"
              :src="imgCodeUrl"
              @click="handleImgCode"
            ></el-image>
          </div>
        </el-form-item>
    -->
          <el-form-item label=""
                        align="center">
            <el-button class="primarya"
                       type="primary"
                       @click="submitForm"
                       :disabled="dengluFF">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
//工具方法
import { getBaseUrl } from "@/request/index.js";
export default {
  name: "login",
  data () {
    return {
      dengluFF: false,
      EchartsWidth: document.body.clientWidth - 190 + "px",
      mimachakan: "N",
      form: {
        user: "",
        pass: "",
        code: "",
        checked: true,
      },
      formRule: {
        user: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        pass: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        // code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      imgCodeUrl: "",
      // 存储token
      token: "",
    };
  },
  beforeRouteEnter (to, form, next) {
    next((vm) => {
      vm.websocketclose();
    });
  },
  created () {
    this.setConfig();
  },
  mounted () {
    document.cookie = "UserId=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
    this.handleImgCode();
  },
  methods: {
    setConfig () {
      getBaseUrl();
    },
    /**
        切换验证码
       */
    handleImgCode () {
      // this.$request({
      //   method: "post",
      //   url: "Users/LoginImgCode",
      // }).then((res) => {
      //   this.imgCodeUrl = "data:image/png;base64," + res.Img;
      //   this.token = res.SessionID;
      // });
    },

    /**提交*/
    submitForm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dengluFF = true;
          let data = {
            ACCOUNT: this.form.user,
            PASSWORD: this.form.pass,
          };
          this.$request({
            method: "post",
            url: "Login/Login",
            data: data,
          })
            .then((res) => {
              this.dengluFF = false;
              if (res.Code == 0 || res.Code == "0") {
                localStorage.setItem("userInfo", JSON.stringify(res.Data));
                localStorage.setItem("tabs", []);
                localStorage.setItem("activeTab", "");
                if (this.form.pass == "123") {
                  window.localStorage.setItem("PASSWORD", "123");
                } else {
                  window.localStorage.setItem("PASSWORD", "");
                }

                // this.initWebSocket()
                window.localStorage.setItem("denglu", "1");
                localStorage.setItem("Token", res.Data.PASSWORD);
                if (res.Data.CustomerInfo !== null) {
                  window.localStorage.setItem(
                    "CustomerInfo",
                    JSON.stringify(res.Data.CustomerInfo)
                  );
                } else {
                  window.localStorage.setItem(
                    "CustomerInfo",
                    JSON.stringify({})
                  );
                }
                localStorage.setItem("loginTime", new Date().getTime()); //存一个时间戳设置登录过期时间
                // sessionStorage.setItem("loginTime", new Date().getTime()); //存一个时间戳设置登录过期时间
                window.localStorage.setItem("yjstartDate", "");
                window.localStorage.setItem("yjendDate", "");
                window.localStorage.setItem("kfyjstartDate", "");
                window.localStorage.setItem("kfyjendDate", "");
                window.localStorage.setItem("kfypjstartDate", "");
                window.localStorage.setItem("kfypjendDate", "");
                window.localStorage.setItem("kfywcstartDate", "");
                window.localStorage.setItem("kfywcendDate", "");
                window.localStorage.setItem("khywcstartDate", "");
                window.localStorage.setItem("khywcendDate", "");
                window.localStorage.setItem("khqbgdstartDate", "");
                window.localStorage.setItem("khqbgdendDate", "");
                window.localStorage.setItem("qbgdstartDate", "");
                window.localStorage.setItem("qbgdendDate", "");
                window.localStorage.setItem("wjstartDate", "");
                window.localStorage.setItem("wjendDate", "");
                window.localStorage.setItem("canyusssqlbstartDate", "");
                window.localStorage.setItem("canyusssqlbendDate", "");
                window.localStorage.setItem("faqisssstartDate", "");
                window.localStorage.setItem("faqisssendDate", "");
                window.localStorage.setItem("qubusssqlbstartDate", "");
                window.localStorage.setItem("qubusssqlbendDate", "");
                this.$router.replace({
                  path: "/home",
                });
              } else {
                let msg = "";
                if (res) {
                  msg = res.Msg;
                }
                this.$confirm(
                  msg +
                  "错误5次后将延迟1小时登录，请谨慎登录！如有问题可联系客服",
                  "提示",
                  {
                    confirmButtonText: "知道了",
                    type: "warning",
                  }
                )
                  .then(() => { })
                  .catch(() => { });
              }
            })
            .catch((err) => {
              this.dengluFF = false;
              if (err == "Error: Request failed with status code 401") {
                this.$router.push({
                  path: "/login",
                });
              }
              let msg = "";
              if (err) {
                msg = err.Msg;
              }

              this.$confirm(
                msg +
                "错误5次后将延迟1小时登录，请谨慎登录！如有问题可联系客服",
                "提示",
                {
                  confirmButtonText: "知道了",
                  type: "warning",
                }
              )
                .then(() => { })
                .catch(() => { });
            });
        } else {
          this.$message({
            message: "补全字段",
            type: "error",
          });
        }
      });
    },

    /**重置*/
    resetForm () {
      this.$refs.form.resetFields();
    },
    /** 回车登录 */
    submitFomrEnter (el) {
      if (el.keyCode == 13) {
        this.submitForm();
      }
    },
    initWebSocket () {
      // this.websock = new WebSocket(
      // 	'ws://123.161.211.74:8059/Socket/LoginConnected'); //这个连接ws://固定，后面的根据自己的IP和端口进行改变，我设置监听的就是8081
      this.websock = new WebSocket(
        "ws://gdapi.zzskzy.com//Socket/LoginConnected"
      ); //这个连接ws://固定，后面的根据自己的IP和端口进行改变，我设置监听的就是8081
      // 'ws://116.63.176.39:8059//Socket/LoginConnected'); //这个连接ws://固定，后面的根据自己的IP和端口进行改变，我设置监听的就是8081
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onerror = this.websocketonerror;
      this.websock.onopen = this.websocketonopen;
      this.websock.onclose = this.websocketclose;
    },

    websocketonopen () {
      // 连接建立之后执行send方法发送数据，这个和自己的后端沟通好需要传什么数据，我的是要进行token验证
      let token = localStorage.getItem("Token");
      console.log(token);
      let data = {
        type: "REGISTER",
        data: {
          token: token,
        },
      };
      console.log("连接成功");

      this.websock.send(JSON.stringify(data));
      console.log(data);
      // this.websock.send("connection");
    },
    websocketonerror () {
      //连接错误
      console.log("WebSocket连接失败");
      this.initWebSocket();
    },
    websocketonmessage (e) {
      // 数据接收);
      console.log("数据接收");
      const h = this.$createElement;
      this.$notify({
        title: "提示",
        message: h(
          "i",
          {
            style: "word-break: break-all;word-wrap: break-word",
          },
          e.data
        ),
        duration: 0,
      });
      // this.$notify({
      // 	title: '提示',
      // 	message: e.data,
      // 	duration: 0
      // });
    },
    websocketclose (e) {
      // 关闭连接
      console.log("已关闭连接", e);
      // this.initWebSocket()
    },
  },
};
</script>

<style scoped>
.login {
  /* 	display: flex;
		padding: 100px; */

  box-sizing: border-box;
  position: absolute;
  left: 0px;
  width: 100%;
  height: 100%;
  background: url("../assets/img/loginBg.jpg") repeat center;
  /* background: url("~assets/fangjia.png") no-repeat center; */
  text-align: center;
  background-size: 100% auto;
}

.loginz {
  box-sizing: border-box;
  background-color: #ffffff;
  position: absolute;
  left: 0px;
  width: 100%;
  height: 100%;
  /* padding: 5px; */
  text-align: center;
}

.loginBg {
  /* position: absolute; */
  width: 100%;
  height: 100%;
  background: #ffffff;
  box-sizing: border-box;
}

/************** 表单样式 *****************/
.form {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  margin: auto 0;
  right: 100px;
  /* width: 540px;
		height: 780px; */
  padding: 20px;
  border-radius: 50px 50px 50px 50px;

  /* background: rgba(255, 255, 255, 0.19); */
  background: #ffffff;
}

.logo {
  position: absolute;
  top: 61px;
  left: 50%;
  margin-left: -50px;

  width: 120px;
  height: 90px;
  background: url("~assets/logo.png") no-repeat center;
  background-size: 100% 100%;
}

.login {
  display: flex;
}
.logo1 {
  /* 	position: absolute;
		left: 50%;
		top: 172px;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
		background: url("~assets/logo1.png")no-repeat center;
		background-size: cover;
		width: 224px;
		height: 78px; */
  margin-top: 10px;
  text-align: center;
  font-size: 18px;

  color: #333333;
  line-height: 0px;
  -webkit-background-clip: text;
}

.form-tit {
  margin-top: 30px;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei-Light, Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 0px;
  -webkit-background-clip: text;
}

/deep/ .el-input__inner {
  height: 42px;
  font-size: 16px;
}

.form-tita {
  text-align: center;
  padding-bottom: 10px;
  font-size: 15px;
  color: #333333;
  font-weight: 300;
}

.form-titxiao {
  margin-top: 0px;
  text-align: left;
  margin-left: 42px;
  padding-bottom: 20px;
  font-size: 18px;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  font-weight: bold;
  color: #666666;
  -webkit-background-clip: text;
}

.form::before {
  content: "";
  display: inline-block;
  position: absolute;
  border: 10px solid transparent;
  border-bottom-color: rgba(255, 255, 255, 0.19);
  left: 50%;
  top: -20px;
  margin-left: -10px;
  z-index: 99;
  width: 0;
  height: 0;
}

.form-code {
  display: flex;
  align-items: center;
}

.form-code-input {
  width: 200px;
}

.form-code-img {
  width: 80px;
  height: 32px;
  margin-left: 20px;
  border-radius: 3px;
}

.form >>> .el-icon-login-user {
  background: url(../assets/img/5.png) center no-repeat;
  background-size: contain;
  width: 15px;
  margin-left: 5px;
}

.form >>> .el-icon-login-pad {
  background: url(../assets/img/4@2x.png) center no-repeat;
  background-size: contain;
  width: 15px;
  margin-left: 5px;
}

.form >>> .el-icon-login-zy {
  background: url(../assets/img/5@2x.png) center no-repeat;
  background-size: contain;
  width: 15px;
  margin-left: 5px;
}

.form >>> .el-icon-login-by {
  background: url(../assets/img/6@2x.png) center no-repeat;
  background-size: contain;
  width: 15px;
  margin-left: 5px;
}

.form-checked {
  display: flex;
  justify-content: flex-start;
  padding-left: 3px;
  box-sizing: border-box;
}

.primarya {
  width: 180px;
  height: 50px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.shurukuanggaodu {
  width: 80%;
  height: 42px;
  margin-left: 40px;
  margin-right: 40px;
}

/************** 登录框样式 *****************/
.el-input >>> .el-input__inner {
  background-color: rgba(255, 255, 255, 0.1);
}

/**登录表单内容 */
.form-con {
  margin-top: 20px;
}
.logintop {
  /* display: flex; */

  /* background: rgba(0, 0, 0, 0.1); */
}
.loginright {
  display: flex;
}
.loginleft {
  width: 600px;
  margin: 40px 40px;
  font-size: 18px;
  /* color: #409eff; */
  color: red;
  font-weight: 550;
  text-indent: 4px;
}
.loginImg {
  width: 260px;
  margin-left: 10px;
  border-radius: 6px;
}
.loginImgIMG {
  width: 600px;
  /* height: 1200px; */
}
.loginImgTop {
  background: red;
  color: #fff;
  width: 260px;
  border-left: 1px solid #f4f4f4;
  border-right: 1px solid #f4f4f4;
  border-top: 1px solid #f4f4f4;
  display: flex;
}
.loginImgTop1 {
  background: red;
  color: #fff;
  width: 260px;
  padding: 10px 0;
  font-size: 16px;
  border-left: 1px solid #f4f4f4;
  /* border-right: 2px solid #000; */
  border-top: 1px solid #f4f4f4;
}
.loginImgTop span {
  display: inline-block;
  padding: 10px 0;
  font-size: 14px;
  border-right: 1px solid #f4f4f4;
}
.loginImgTop span:nth-child(2) {
  width: 190px;
}
.loginImgTop span:nth-child(1) {
  width: 70px;
}
.loginImgTop:last-child {
  border-bottom: 1px solid #f4f4f4;
}
</style>
